import { tierColor } from '../../../../modules/odds/tierStyles';

/** Rarities that have a themeable `--ui-badge-*` palette token in
 *  `index.css`. For these we route through the CSS var (so an operator's
 *  theme recolours them) and keep the matching hex only as a fallback.
 *  Other tier names (Legendary / Grail / custom) fall back to the shared
 *  {@link tierColor} map directly. */
const THEMED_TIERS = new Set(['common', 'uncommon', 'rare', 'epic']);

/**
 * Base colour for a rarity bar — a CSS colour expression, themeable where
 * a palette token exists. Uses the same source of truth as the classic
 * TierDot ({@link tierColor}) so the rarity colour system stays uniform
 * across templates. See [[feedback_iframe_theme_vars]].
 */
export function tierBarColor(name: string): string {
  const hex = tierColor(name);
  const slug = name.trim().toLowerCase();
  return THEMED_TIERS.has(slug) ? `var(--ui-badge-${slug}, ${hex})` : hex;
}

/** Inline styles for a single rarity bar's fill + inner glow, derived from
 *  the rarity colour. The fill is a subtle dark→base horizontal gradient
 *  (mirrors Figma `1382:15625`); the glow is a soft inner shadow tinted by
 *  the same colour. */
export function tierBarFillStyle(name: string): React.CSSProperties {
  const c = tierBarColor(name);
  return {
    backgroundImage: `linear-gradient(90deg, color-mix(in srgb, ${c} 82%, #000) 0%, ${c} 100%)`,
    boxShadow: `inset 0 0 57px 0 color-mix(in srgb, ${c} 25%, transparent)`,
  };
}
